var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigsmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.341,
    height: 188.341,
    viewBox: "0 0 188.341 188.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_454",
    "data-name": "Grupo 454",
    transform: "translate(-39.818 -39.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_430",
    "data-name": "Grupo 430",
    transform: "translate(39.818 39.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_426",
    "data-name": "Grupo 426",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_425",
    "data-name": "Grupo 425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1259_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1260_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1261_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1262_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1263_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1264_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1265_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1266_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1558_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1559_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1560_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1561_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1562_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1563_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1564_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_153",
    "data-name": "Elipse 153",
    cx: 94.17,
    cy: 94.17,
    r: 94.17,
    fill: "#fed940"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_431",
    "data-name": "Grupo 431",
    transform: "translate(86.447 81.835)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_154",
    "data-name": "Elipse 154",
    cx: 14.993,
    cy: 14.993,
    r: 14.993,
    fill: "#634c4c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_155",
    "data-name": "Elipse 155",
    cx: 14.993,
    cy: 14.993,
    r: 14.993,
    transform: "translate(65.099)",
    fill: "#634c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_432",
    "data-name": "Grupo 432",
    transform: "translate(78.305 130.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_590",
    "data-name": "Caminho 590",
    d: "M260.978,250a69.486,69.486,0,0,1-2.6,18.931,65.714,65.714,0,0,1-7.867,17.617,61.1,61.1,0,0,1-5.846,7.741c-10.075,11.337-24,18.345-39.375,18.345-18.628,0-35.114-10.285-45.221-26.086a65.714,65.714,0,0,1-7.867-17.617A69.487,69.487,0,0,1,149.61,250Z",
    transform: "translate(-149.61 -250)",
    fill: "#634c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_591",
    "data-name": "Caminho 591",
    d: "M311.684,250a69.488,69.488,0,0,1-2.6,18.931,65.715,65.715,0,0,1-7.867,17.617,61.1,61.1,0,0,1-5.846,7.741c-10.075,11.337-24,18.345-39.375,18.345V250Z",
    transform: "translate(-200.316 -250)",
    fill: "#634c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_592",
    "data-name": "Caminho 592",
    d: "M259.4,327.465c-9.939,10.463-23.307,16.864-38,16.864s-28.059-6.4-38-16.864c8.055-6.6,22.066-10.965,38-10.965S251.342,320.865,259.4,327.465Z",
    transform: "translate(-165.71 -281.694)",
    fill: "#fc3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_594",
    "data-name": "Caminho 594",
    d: "M260.978,250a69.488,69.488,0,0,1-2.6,18.931H152.206A69.486,69.486,0,0,1,149.61,250Z",
    transform: "translate(-149.61 -250)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigsmile);
export default __webpack_public_path__ + "static/media/bigsmile.f53a53fc8efc4752e68f47f37e790f95.svg";
export { ForwardRef as ReactComponent };